// AUTH index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    showAppViews: false,
    userLogged: false,
    token: '',
    bootstrapComplete: false,
    info: null,
    subaccounts: [],
    activeSubaccount: localStorage.getItem('subaccount') && localStorage.getItem('subaccount') !== 'undefined' ? JSON.parse(localStorage.getItem('subaccount')) : '',
  },
  actions,
  mutations,
  getters,
};
